import { render, staticRenderFns } from "./VCardList.vue?vue&type=template&id=93e1a6c0"
import script from "./VCardList.vue?vue&type=script&lang=js"
export * from "./VCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93e1a6c0')) {
      api.createRecord('93e1a6c0', component.options)
    } else {
      api.reload('93e1a6c0', component.options)
    }
    module.hot.accept("./VCardList.vue?vue&type=template&id=93e1a6c0", function () {
      api.rerender('93e1a6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/pos/pos/components/complements/VCardList.vue"
export default component.exports